import 'dayjs/locale/pt-br';
import domtoimage from 'dom-to-image';
import { inPlaceSort } from 'fast-sort';
import jsPDF from 'jspdf';
import { useEffect, useMemo, useState, useRef } from 'react';
import { sharePdfFromNode } from '../../core/utils/generatePdfWithImages';
import { isMobile, isIOS } from 'react-device-detect';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import { BiWindow, BiWindows } from 'react-icons/bi';
import 'react-tabs/style/react-tabs.css';
import { DefaultButton } from '../../components/Button/Button';
import PieceEdit from '../../components/PieceEdit/PieceEdit';
import { BodyShopAddScreen } from '../BudgetAdd/BodyShopAddScreen';
import BudgetAddAeServiceScreen from '../BudgetAddAeService/BudgetAddAeServiceScreen';
import BudgetAddClient from '../BudgetAddClient/BudgetAddClient';
import BudgetAddVehicle from '../BudgetAddVehicle/BudgetAddVehicle';
import PieceAddScreen from '../PieceAdd/PieceAddScreen';
import { HasEditedStatusProvider } from './components/HasEditedContext';
import { BudgetTabs } from './components/TabsContent';
import { getTotalSum } from './utils/functions';
('pt-br');

const ModalBudget = ({
  values,
  closeModal,
  onClone,
  isNew,
  onChange,
  onSave,
  compareValues,
  onRemove,
  budget,
  showBudgetItems,
  open,
  setOpen,
  addBudget,
  client,
  clientLoading,
  vehicle,
  vehicleLoading,
  bodyshopService,
  setBodyshopService,
  setBodyshopServiceVersion,
  aeService,
  setAeService,
  part,
  setPart,
  parts,
  setParts,
  onRemovePiece,
  onRemoveService,
  onRemoveAeService,
  setReload,
  hvTable,
  setAddBudget,
  sendWhatsapp,
  setIsntLinearHour,
  isntLinearHour,
  serviceType,
  setServiceType,
  addedParts,
  addedServices,
  paymentOptions,
  createOption,
  changeValue,
  changePartsValue,
  reloadPrint,
  company,
  isOpen,
  setIsOpen,
  openEditModal,
  onChangePiece,
  printCompany,
  deleteOptions,
  createOrigin,
  divCreatable,
  menuOpen,
  creatableOpen,
  changeValueAeService,
  setHasCreated,
  setOldValues,
  setReloadPrint,
  setValues,
  reloadConsultants,
  reloadPaymentOptions,
}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentClientId, setCurrentClientId] = useState(0);
  const [currentVehicleId, setCurrentVehicleId] = useState(0);
  const timeoutsRef = useRef([]);

  // Cleanup de timeouts ao desmontar componente
  useEffect(() => {
    return () => {
      timeoutsRef.current.forEach(timeout => clearTimeout(timeout));
      timeoutsRef.current = [];
    };
  }, []);

  const totalSum = useMemo(
    () => getTotalSum(bodyshopService, parts, aeService),
    [bodyshopService, parts, aeService]
  );
  const totalBodyshopService = useMemo(
    () => getTotalSum(bodyshopService, [], []),
    [bodyshopService]
  );
  const totalParts = useMemo(() => getTotalSum([], parts, []), [parts]);
  const totalAeService = useMemo(
    () => getTotalSum([], [], aeService),
    [aeService]
  );

  const nodeInBlob = async () => {
    return new Promise((resolve, reject) => {
      // const printWindow = window.open("", "_blank");
      // printWindow.document.write(ref.current.outerHTML);
      // printWindow.focus();
      const timeout = setTimeout(() => {
        // const blob = new Blob([ref.current.outerHTML], {
        //   type: "application/pdf",
        // });
        var node = document.getElementById('my-node');
        domtoimage.toPng(node).then(function (dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          resolve(img);
        }).catch(reject);
      }, 2000);

      // Armazenar referência do timeout para cleanup
      timeoutsRef.current.push(timeout);
    });
  };

  async function generateAndSharePDF(title) {
    // So o iOS usa html2canvas (dom-to-image quebra as imagens no iPhone).
    if (isIOS) {
      const node = document.getElementById('my-node');
      if (!node) {
        console.error("Elemento com ID 'my-node' não encontrado no DOM.");
        return;
      }
      try {
        await sharePdfFromNode(node, title);
      } catch (error) {
        console.error('Erro ao gerar ou compartilhar o PDF:', error);
      }
      return;
    }

    // Android/desktop: método original (dom-to-image + jsPDF), que funciona.
    const element = document.getElementById('print-padding-mobile');
    if (!element) {
      console.error(
        "Elemento com ID 'print-padding-mobile' não encontrado no DOM."
      );
      return;
    }
    try {
      const pixelToPt = 0.75;
      const a4WidthPt = 595;
      const a4HeightPt = 842;
      const imgData = await domtoimage.toPng(element);
      const elementWidth = element.offsetWidth * pixelToPt;
      const elementHeight = element.offsetHeight * pixelToPt;
      const scale = Math.min(
        a4WidthPt / elementWidth,
        a4HeightPt / elementHeight
      );
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: [a4WidthPt, a4HeightPt],
      });
      pdf.addImage(
        imgData,
        'PNG',
        0,
        0,
        elementWidth * scale,
        elementHeight * scale
      );
      const pdfBlob = pdf.output('blob');
      if (navigator.share) {
        await navigator.share({
          title: 'Compartilhar PDF',
          files: [new File([pdfBlob], title, { type: 'application/pdf' })],
        });
      } else {
        console.error('A API navigator.share não é suportada.');
      }
    } catch (error) {
      console.error('Erro ao gerar ou compartilhar o PDF:', error);
    }
  }

  const toShare = async () => {
    try {
      setIsLoading(true);
      const sanitizedClientName = values.client_name.replace(/[\s\\/]/g, '_');
      const sanitizedVehicleName = values.vehicle_name.replace(/[\s\\/]/g, '_');
      const newTitle = `Orcamento_${values.code}_${sanitizedClientName}_${sanitizedVehicleName}.pdf`;

      generateAndSharePDF(newTitle);
    } catch (error) {
      console.error('Erro ao compartilhar:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const sortedPaymentOptions = paymentOptions.map((item) => ({
    value: item.payment_type.value,
    label: item.payment_type.label,
    id: item.id,
  }));

  inPlaceSort(sortedPaymentOptions).asc([
    (item) => item.label.replace(/[^a-zA-Z]/g, '').toLowerCase(),
    (item) => {
      const numberMatch = item.label.match(/\d+/);
      return numberMatch ? parseInt(numberMatch[0], 10) : 0;
    },
  ]);

  useEffect(() => {
    const prosperaModal = document.querySelector('.prospera-modal');
    const modalContent = document.querySelector('.modal-content');
    const mainModal = document.querySelector('.main-content-modal1');
    const modalWrapper = document.querySelector('.modal-content-wrapper');
    // const textArea = document.querySelector('.text-observation-min');
    // const textArea1 = document.querySelector('.text-observation-min2');
    const serviceAdditionalArea = document.querySelector(
      '.service-additional-on'
    );
    const pieceGridtable = document.querySelector('.piece-gridtable');
    const serviceGridtable = document.querySelector('.service-gridtable');
    if (modalContent) {
      modalContent.style.backgroundColor = isFullscreen ? '#4b4b4d' : '#fff';
    }

    if (prosperaModal) {
      prosperaModal.classList.toggle('expanded', !isFullscreen);
      prosperaModal.classList.toggle('prospera-modal-fullscreen', isFullscreen);

      mainModal.classList.toggle('main-content-modal2', isFullscreen);
      modalWrapper.classList.toggle('modal-content-wrapper2', isFullscreen);
    }
    if (serviceAdditionalArea) {
      serviceAdditionalArea.classList.toggle(
        'service-additional-off',
        isFullscreen
      );
    }
    if (pieceGridtable) {
      pieceGridtable.classList.toggle('fullscreen-gridtable', isFullscreen);
    }
    if (serviceGridtable) {
      serviceGridtable.classList.toggle('fullscreen-gridtable', isFullscreen);
    }
  }, [isFullscreen]);

  useEffect(() => {
    const modal = document.querySelector('.modal');
    if (modal) {
      if (isLoading) {
        modal.classList.add('loading');
      } else {
        modal.classList.remove('loading');
      }
    }
  }, [isLoading]);

  inPlaceSort(bodyshopService).by('title');
  inPlaceSort(parts).by('part');

  return (
    <HasEditedStatusProvider>
      <div className={''}>
        <div className={'modal-container'}>
          <div className="modal-header">
            <div className="header-title">
              <h4 className="modal-title">
                {isNew
                  ? 'Adicionar Orçamento'
                  : `Editar Orçamento${values?.code ? ` — ${values.code}` : ''}`}
              </h4>
            </div>
            <div className="header-buttons">
              {compareValues ? (
                <DefaultButton
                  className="modal-footer-button"
                  label={isMobile ? '' : 'Salvar'}
                  icon={<AiOutlineCheck className="button-icon" />}
                  onClick={onSave}
                />
              ) : (
                <div />
              )}
              {isMobile ? (
                <div />
              ) : (
                <DefaultButton
                  className="modal-footer-button cancel"
                  onClick={() => {
                    setIsFullscreen(!isFullscreen);
                    showBudgetItems(1);
                  }}
                  icon={!isFullscreen ? <BiWindow /> : <BiWindows />}
                />
              )}
              <DefaultButton
                className="modal-footer-button cancel"
                label={isMobile ? '' : 'Cancelar'}
                icon={<AiOutlineClose className="button-icon-cancel" />}
                onClick={closeModal}
              />
            </div>
          </div>

          <BudgetTabs
            budget={budget}
            showBudgetItems={showBudgetItems}
            onChange={onChange}
            client={client}
            clientLoading={clientLoading}
            values={values}
            setOpen={setOpen}
            vehicle={vehicle}
            vehicleLoading={vehicleLoading}
            menuOpen={menuOpen}
            creatableOpen={creatableOpen}
            createOption={createOption}
            divCreatable={divCreatable}
            deleteOptions={deleteOptions}
            paymentOptions={paymentOptions}
            company={company}
            isFullscreen={isFullscreen}
            isntLinearHour={isntLinearHour}
            hvTable={hvTable}
            setIsntLinearHour={setIsntLinearHour}
            bodyshopService={bodyshopService}
            onRemoveService={onRemoveService}
            changeValue={changeValue}
            onRemovePiece={onRemovePiece}
            changePartsValue={changePartsValue}
            openEditModal={openEditModal}
            parts={parts}
            isOpen={isOpen}
            onRemoveAeService={onRemoveAeService}
            aeService={aeService}
            compareValues={compareValues}
            sendWhatsapp={sendWhatsapp}
            toShare={toShare}
            isLoading={isLoading}
            onRemove={onRemove}
            onClone={onClone}
            onSave={onSave}
            totalParts={totalParts}
            totalSum={totalSum}
            totalBodyshopService={totalBodyshopService}
            totalAeService={totalAeService}
            changeValueAeService={changeValueAeService}
            reloadPrint={reloadPrint}
            printCompany={printCompany}
            setCurrentClientId={setCurrentClientId}
            setCurrentVehicleId={setCurrentVehicleId}
            setHasCreated={setHasCreated}
            setOldValues={setOldValues}
            setReloadPrint={setReloadPrint}
            setValues={setValues}
            reloadConsultants={reloadConsultants}
            reloadPaymentOptions={reloadPaymentOptions}
          />
        </div>
      </div>

      <BodyShopAddScreen
        compareValues={compareValues}
        service={bodyshopService}
        addedServices={addedServices}
        serviceType={serviceType}
        setServiceType={setServiceType}
        showBudgetItems={showBudgetItems}
        budget={addBudget}
        setAddBudget={setAddBudget}
        isOpen={open === 1}
        values={values}
        isntLinearHour={isntLinearHour}
        setValues={(newValues) => {
          const updatedValues = Array.isArray(newValues)
            ? newValues
            : [newValues];
          const filteredValues = updatedValues.filter(
            (value) => value && value.title
          );

          if (filteredValues.length > 0) {
            setBodyshopService((service) => [...service, ...filteredValues]);
            setBodyshopServiceVersion((v) => v + 1);
          }
        }}
        setOpen={setOpen}
      />
      <PieceAddScreen
        addedParts={addedParts}
        showBudgetItems={showBudgetItems}
        budget={addBudget}
        isOpen={open === 2}
        partsArray={parts}
        setValues={(values) => setParts((part) => [...part, ...values])}
        setOpen={setOpen}
      />
      <BudgetAddClient
        showBudgetItems={showBudgetItems}
        budget={addBudget}
        isOpen={open === 3}
        setReload={setReload}
        setOpen={setOpen}
        createOrigin={createOrigin}
        values={values}
        currentClientId={currentClientId}
      />
      <BudgetAddVehicle
        showBudgetItems={showBudgetItems}
        budget={addBudget}
        isOpen={open === 4}
        setOpen={setOpen}
        setReload={setReload}
        defaultValues={values}
        currentVehicleId={currentVehicleId}
      />

      <BudgetAddAeServiceScreen
        compareValues={compareValues}
        service={aeService}
        addedServices={addedServices}
        serviceType={serviceType}
        setServiceType={setServiceType}
        showBudgetItems={showBudgetItems}
        budget={addBudget}
        setAddBudget={setAddBudget}
        isOpen={open === 5}
        values={values}
        isntLinearHour={isntLinearHour}
        setValues={(newValues) => {
          const updatedValues = Array.isArray(newValues)
            ? newValues
            : [newValues];
          const filteredValues = updatedValues.filter(
            (value) => value && value.title
          );

          if (filteredValues.length > 0) {
            setAeService((service) => [...service, ...filteredValues]);
          }
        }}
        setOpen={setOpen}
      />

      <PieceEdit
        isOpen={isOpen}
        setOpen={setIsOpen}
        parts={parts}
        setParts={setParts}
        part={part}
        setPart={setPart}
        values={values}
        onChangePiece={onChangePiece}
      />
    </HasEditedStatusProvider>
  );
};

export default ModalBudget;
